// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuButtonInactive_container__3Xucq","fa":"MenuButtonInactive_fa__2Vluo"};